import ReactPaginate from 'react-paginate'
import C from '@utilities/constants'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'

type Props = { page: number; totalPages: number; pageChange: any }

const Pagination = ({ page, totalPages, pageChange }: Props) => {
  return (
    <ReactPaginate
      previousLabel={<FaChevronLeft />}
      previousClassName="flex items-center"
      nextLabel={<FaChevronRight />}
      nextClassName="flex items-center"
      breakLabel="..."
      forcePage={page - 1}
      pageCount={totalPages}
      marginPagesDisplayed={1}
      pageRangeDisplayed={C.DEFAULT.PAGINATION.PAGE_NUMBER_SHOWING - 2}
      onPageChange={({ selected }) => pageChange(selected + 1)}
      containerClassName="flex md:text-sm"
      activeClassName="font-bold bg-bidfta-blue-light text-white"
      pageLinkClassName="block p-2 border border-gray-300 w-10 flex justify-center"
      previousLinkClassName="block p-2 border border-gray-300 h-full flex items-center"
      nextLinkClassName="block p-2 border border-gray-300 h-full flex items-center"
      breakClassName="block px-2 pb-3 pt-1 border border-gray-300 w-10 flex justify-center items-center h-full "
      breakLinkClassName="h-full flex items-center"
    />
  )
}

export default Pagination
